import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { ZohoValueEntity } from '../../domain/entities/ZohoValueEntity'
export class ZohoValueModel extends ZohoValueEntity {
  constructor(dataDto: ZohoValueEntity) {
    super()
    mapEntityProperties<ZohoValueModel>(this, dataDto)
  }
}
